<template>
  <!-- 回款记录详情 -->
  <div>
    <div class="main">
      <div class="titleText">回款记录（{{ dataValue.id }}）</div>
      <a-row class="row" v-for="(item, index) in detailsObj" :key="index">
        <a-col v-for="(el, ind) in item" :key="ind" :span="el.span">
          <div class="label">
            <div>{{ el.label }}</div>
            <span v-if="!el.slot" class="value">{{ dataValue[el.value] }}</span>
            <span
              v-else-if="el.slot === 'backStatusSlot'"
              class="value"
            >{{ dataValue[el.value] === 0 ? '未回款' : '已回款' }}</span>
            <span v-else-if="el.slot === 'backInvoiceSlot'" class="value">
              <a-tag v-if="dataValue[el.value] === 0" color="orange">未开票</a-tag>
              <span v-else-if="dataValue[el.value] === 1">
                <a-tag color="green">已开票</a-tag>
                <span
                  v-if="priShow"
                  style="color:#0079FE;margin:0 10px;cursor:pointer;"
                  @click="backInvoiceClick"
                >{已生成对应的开票记录}</span>
              </span>
              <a-tag v-else>无需开票</a-tag>
            </span>
            <span
              v-else-if="el.slot === 'dateSlot'"
              class="value"
            >{{ dataFilter(dataValue[el.value]) }}</span>
            <span
              v-else-if="el.slot === 'dictDataSlot'"
              class="value"
            >{{ getDictName(el.listName, dataValue[el.value]) }}</span>
            <span
              v-else-if="el.slot === 'backMoney'"
              class="value"
            >{{parseFloat(dataValue[el.value]).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            <span
              v-else-if="el.slot === 'backCxMoney'"
              class="value"
            >{{parseFloat(dataValue[el.value]).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            <span v-else-if="el.slot === 'projectName'" class="value">{{ dataValue[el.value] }}</span>
            <span v-else-if="el.slot === 'customerName'" class="value">{{ dataValue[el.value] }}</span>
            <!-- <div v-else-if="el.slot === 'checkDataSlot'" class="value" style="width: 98%;">
              <audit-process-vue ref="auditRef" style="width: 100%;text-align:left;font-weight: 400;"/>
            </div>-->
            <a-table
              v-else-if="el.slot === 'payBackListSlot' && tableData && tableData.length > 0"
              bordered
              size="small"
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :rowKey="(record,index)=>{return index}"
              style="width: 85%;"
            />

            <div v-else-if="el.slot === 'fileIdsSlot'" style="width: 85%;">
              <!-- <upload-attachment v-if="dataValue.fileIds" ref="uploadRef" :upload-if="false" :upload-if-no="false"/> -->
              <div v-if="dataValue.fileIds">
                <a-table
                  size="small"
                  bordered
                  :columns="columnsFile"
                  :data-source="fileObj"
                  :pagination="false"
                  :rowKey="(record,index)=>{return index}"
                >
                  <template slot="operation" slot-scope="text, record, index">
                    <a-icon
                      v-if="isPreview(record)"
                      class="icon-pointer"
                      type="eye"
                      :style="{ color: 'blue' }"
                      title="预览"
                      @click="showClick(record, index)"
                      style="margin-right: 10px;"
                    />
                    <!-- <a-icon class="icon-pointer" type="cloud-download" :style="{ color: 'blue' }" title="下载" @click="downloadClick(record)" style="margin-right: 10px;"/> -->
                  </template>
                </a-table>
              </div>
              <span v-else>暂无附件</span>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { dealBigMoney } from '@/utils/common'
import uploadAttachment from '@/views/common/Upload.vue'
// import {getCustomerNameById, getProjectNameById, getContractNameById} from '../../../utils/index'

export default {
  name: 'hkjlhz',
  components: { uploadAttachment },
  provide () {
    return {
      formData: this
    }
  },
  data () {
    return {
      dictData: {},
      dataValue: {},
      priShow: false,
      resData: [],
      detailsObj: [
        [
          {
            label: '对应项目:',
            value: 'projectName',
            span: 24,
            slot: 'projectName'
          }
        ],
        [
          {
            label: '对应客户:',
            value: 'customerName',
            span: 24,
            slot: 'customerName'
          }
        ],
        [
          {
            label: '公司账户:',
            value: 'companyAccount',
            span: 24,
            slot: 'dictDataSlot',
            listName: 'comAccountObj'
          }
        ],
        [
          {
            label: '合同订单:',
            value: 'contractName',
            span: 24
          }
        ],
        [
          {
            label: '款项日期:',
            value: 'backDate',
            span: 12,
            slot: 'dateSlot'
          },
          {
            label: '期次:',
            value: 'period',
            span: 12
          }
        ],
        [
          {
            label: '回款金额:',
            value: 'backMoney',
            span: 24,
            slot: 'backMoney'
          }
        ],
        [
          {
            label: '冲销金额:',
            value: 'backCxMoney',
            span: 24,
            slot: 'backCxMoney'
          }
        ],
        [
          {
            label: '计业绩金额:',
            value: 'backYjMoney',
            span: 12
          },
          {
            label: '计业绩备注:',
            value: 'bz',
            span: 12
          }
        ],
        [
          {
            label: '回款方式:',
            value: 'backPayMode',
            span: 12,
            slot: 'dictDataSlot',
            listName: 'returnedMoneyMethodsObj'
          },
          {
            label: '回款类别:',
            value: 'backClassify',
            span: 12,
            slot: 'dictDataSlot',
            listName: 'returnedMoneyTypeObj'
          }
        ],
        [
          {
            label: '负责人:',
            value: 'dutyPerson',
            span: 12
          },
          {
            label: '所有者:',
            value: 'backOwner',
            span: 12
          }
        ],
        [
          {
            label: '备注:',
            value: 'backRemark',
            span: 24
          }
        ],
        [
          {
            label: '是否开票:',
            value: 'backInvoice',
            span: 24,
            slot: 'backInvoiceSlot'
          }
        ],
        [
          {
            label: '对应计划:',
            value: 'payBackList',
            span: 24,
            slot: 'payBackListSlot'
          }
        ],
        [
          {
            label: '抄送对象:',
            value: 'userName',
            span: 24
          }
        ],
        // [
        //   {
        //     label: '审核记录:',
        //     value: 'checkData',
        //     span: 24,
        //     slot: 'checkDataSlot'
        //   }
        // ],
        [
          {
            label: '附件列表:',
            value: 'fileIds',
            span: 24,
            slot: 'fileIdsSlot'
          }
        ]
      ],
      tableData: [],
      columns: [
        {
          width: '32%',
          align: 'center',
          title: '计划日期',
          dataIndex: 'backDate'
        },
        {
          width: '32%',
          align: 'center',
          title: '计划额',
          dataIndex: 'backMoney'
        },
        {
          width: '32%',
          align: 'center',
          title: '计划冲销额',
          dataIndex: 'backCxMoney'
        }
      ],
      columnsFile: [
        {
          width: '40%',
          ellipsis: true,
          title: '文件名',
          dataIndex: 'oldName',
          align: 'center'
        },
        {
          title: '上传时间',
          width: '30%',
          dataIndex: 'time',
          align: 'center'
        }, {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      fileObj: [],
      fileIdList: [],
      billVisibles: false
    }
  },
  mounted () {
    this.setFormData(this.$route.query.id)
  },
  methods: {
    dealBigMoney,
    dataFilter (val) {
      if (val) return val.slice(0, 10)
    },
    getDictName (objVal, val) {
      if (val) {
        if (this.dictData[objVal]) {
          return this.dictData[objVal][val]
        }
      }
    },
    setFormData (id) {
      this.dictData = this.$store.state.account.dictData
      this.$get('/payBack/getById', { id: id }).then(res => {
        let resData = res.data
        if (resData.status === 1) {
          this.dataValue = resData.data
          this.tableData = resData.data.payBackList
          if (this.dataValue.fileIds) {
            let fileList = this.dataValue.fileIds.split(',')
            this.fileObj = []
            this.fileIdList = []
            this.$get('/file/getFileByIds', { fileIds: fileList.join(',') }).then(res => {
              if (res.data.status === 1) {
                let resDataList = res.data.data
                resDataList.forEach(element => {
                  this.fileObj.push({
                    id: element.fileId,
                    oldName: element.oldName,
                    time: element.time,
                    accessUrl: element.accessUrl,
                    fileSuffix: element.fileSuffix
                  })
                  this.fileIdList.push(element.fileId)
                })
              }
            })
            // if (fileList.length > 0) {
            //   this.setValue(false)
            // }
            // setTimeout(() => {
            //   this.getUrlDetails()
            // }, 200)
          }
        } else {
          this.$message.warning(resData.message)
        }
      })
    },
    isPreview (itemVal) { // 是否支持预览
      if (itemVal.fileSuffix === '.png' || itemVal.fileSuffix === '.jpg' || itemVal.fileSuffix === '.pdf' || itemVal.fileSuffix === '.JPG') {
        return true
      } else {
        return false
      }
    },
    imgPrev () {
      this.$refs.img.prev()
    },
    imgNext () {
      this.$refs.img.next()
    },
    previewCacel () {
      this.previewVisible = false
      this.previewImage = ''
      this.yulanArr = []
    },
    showClick (itemRow, indexVal) { // 预览附件
      if (itemRow.fileSuffix === '.pdf') {
        window.open(this.$baseURL + itemRow.accessUrl)
      } else {
        this.previewVisible = true
        // 对图片类型的附件-支持轮播预览
        let arr = []
        this.fileObj.forEach(element => {
          if (!element.showImgUrl) {
            this.getImgUrl(this.$baseURL + element.accessUrl).then(res => {
              this.$set(element, 'showImgUrl', res)
            })
          }
          if (element.fileSuffix === '.png' || element.fileSuffix === '.jpg' || element.fileSuffix === '.JPG') {
            arr.push(element)
          }
        })
        // 点击预览某一张时(不为第一张) 将数组调整顺序
        if (indexVal >= 0) {
          let firstArr = arr.splice(indexVal, this.fileObj.length)
          let endArr = arr.splice(0, indexVal)
          this.yulanArr = [...firstArr, ...endArr]
          // console.log('yulanArr', this.yulanArr)
        }
      }
    },
    getImgUrl (urlParams) {
      return new Promise((resolve, reject) => {
        let returnVal = ''
        axios({
          method: 'GET',
          url: urlParams,
          responseType: 'arraybuffer',
          headers: {
            'Authentication': this.$store.state.account.token
          }
        }).then(res => {
          returnVal = 'data:image/png;base64,' + btoa(
            new Uint8Array(res.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          resolve(returnVal)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    downloadClick (itemVal) { // 下载附件
      this.$download('/file/downloadFile', { fileId: itemVal.id }, itemVal.oldName)
    }
  }
}
</script>

<style  lang="less"  scoped>
.main {
  width: 100%;
  .row {
    padding: 10px 10px;
    border-bottom: 1px dashed #e8e8e8;
    .label {
      color: #7b7d81;
      vertical-align: middle;
      display: flex;
      // div:first-child{
      //   font-weight: 600;
      //   width: 80px;
      //   letter-spacing: 1px;
      //   text-align: right;
      //   margin-right: 10px;
      // }
    }
    .value {
      color: #333;
      vertical-align: middle;
      padding-left: 8px;
    }
  }
}
/deep/ .ant-modal {
  padding-bottom: 0;
  box-sizing: border-box;
  .ant-modal-content {
    min-height: auto;
  }
}
.summary-item {
  text-align: center;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #fafafa;
  .summary-item-value {
    font-size: 24px;
    font-weight: 600;
    color: #1890ff;
    font-size: 16px;
    .amount {
      font-size: 26px;
      font-weight: bold;
    }
  }
  .summary-item-text {
    font-size: 14px;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contractManage/paymentPlan/hkjlhz.vue